import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function ExploreMore() {
    const { t } = useTranslation('explore');

    return (
        <section className="explore-more">
            <p className="explore-more__eyebrow">{t('more.eyebrow')}</p>
            <h2>{t('more.title')}</h2>

            <Link className="explore-more__hero" to="/red-packet">
                <div className="explore-more__hero-copy">
                    <span className="explore-more__kicker">{t('more.redPackets.eyebrow')}</span>
                    <h3>{t('more.redPackets.title')}</h3>
                    <p>{t('more.redPackets.description')}</p>
                </div>
                <div className="explore-more__hero-art" aria-hidden>
                    <div className="explore-more__envelope">
                        <span className="explore-more__envelope-brand">{t('more.redPackets.brand')}</span>
                        <span className="explore-more__envelope-plus">
                            <PlusOutlined />
                        </span>
                        <span className="explore-more__envelope-caption">{t('more.redPackets.caption')}</span>
                    </div>
                </div>
            </Link>

            <div className="explore-more__grid">
                <article className="explore-more__card">
                    <span className="explore-more__kicker">{t('more.prediction.eyebrow')}</span>
                    <h3>{t('more.prediction.title')}</h3>
                    <p>{t('more.prediction.description')}</p>
                    <span className="explore-more__soon">{t('more.comingSoon')}</span>
                </article>
                <article className="explore-more__card">
                    <span className="explore-more__kicker">{t('more.perpetuals.eyebrow')}</span>
                    <h3>{t('more.perpetuals.title')}</h3>
                    <p>{t('more.perpetuals.description')}</p>
                    <span className="explore-more__soon">{t('more.comingSoon')}</span>
                </article>
            </div>
        </section>
    );
}

export default ExploreMore;
